import { Col, Row } from "antd";
import { get, set } from "lodash";
import { useTranslation } from "react-i18next";
import { MdOutlineFreeCancellation } from "react-icons/md";
import Form from "shared/components/Form";
import FormField from "shared/components/FormField";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";

const MemberShip = ({
  setPercent,
  setDisabled,
  isFieldRequired,
  initialValues,
  bindField,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const MEMBERSHIP = t(
    "SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.LAFPAC_MEMBERSHIP",
    {
      returnObjects: true,
    },
  );

  const MEMBERSHIP_STATUS = {
    [true]: () => {
      set(
        initialValues,
        "project.contact.fields.requestLafpacMemberShip",
        true,
      );
      set(initialValues, "project.contact.fields.alreadyLafpacMember", false);
      set(initialValues, "project.contact.fields.lafpacMemberShipNumber", null);
      setDisabled((prev) => ({
        ...prev,
        project: {
          ...prev?.project,
          contact: {
            ...prev?.project?.contact,
            fields: {
              ...prev?.project?.contact?.fields,
              lafpacMemberShipNumber: true,
            },
          },
        },
      }));
    },
    [false]: () => {
      set(
        initialValues,
        "project.contact.fields.requestLafpacMemberShip",
        false,
      );
      set(initialValues, "project.contact.fields.alreadyLafpacMember", true);
      setDisabled((prev) => ({
        ...prev,
        project: {
          ...prev?.project,
          contact: {
            ...prev?.project?.contact,
            fields: {
              ...prev?.project?.contact?.fields,
              lafpacMemberShipNumber: false,
            },
          },
        },
      }));
    },
  };

  const requestMembershipPath =
    "project.contact.fields.requestLafpacMemberShip";
  const requestMembershipField = bindField(requestMembershipPath, {
    label: MEMBERSHIP.REQUEST_MEMBERSHIP,
    onChange: (value) => {
      MEMBERSHIP_STATUS[value]();
      setPercent(initialValues);
    },
  });

  const alreadyMemberPath = "project.contact.fields.alreadyLafpacMember";
  const alreadyMemberField = bindField(alreadyMemberPath, {
    label: MEMBERSHIP.ALREADY_MEMBER,
    onChange: (value) => {
      MEMBERSHIP_STATUS[!value]();
      setPercent(initialValues);
    },
  });

  const membershipNumberPath =
    "project.contact.fields.lafpacMemberShipNumber";
  const membershipNumberField = bindField(membershipNumberPath, {
    label: MEMBERSHIP.MEMBERSHIP_NUMBER.LABEL,
    required: true,
    onBlur: () => setPercent(initialValues),
  });

  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.LAFPAC_MEMBERSHIP}-section`}
    >
      <Form type="vertical" title={MEMBERSHIP.TITLE}>
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <FormField
              path={requestMembershipField.path}
              label={requestMembershipField.label}
              required={requestMembershipField.required}
              disabled={requestMembershipField.disabled}
            >
              {(field) => (
                <Input
                  type="switch"
                  label={requestMembershipField.label}
                  checked={get(initialValues, requestMembershipPath) === true}
                  {...field}
                  onChange={requestMembershipField.onChange}
                />
              )}
            </FormField>
          </Col>
          <Col lg={24} xs={24}>
            <FormField
              path={alreadyMemberField.path}
              label={alreadyMemberField.label}
              required={alreadyMemberField.required}
              disabled={alreadyMemberField.disabled}
            >
              {(field) => (
                <Input
                  type="switch"
                  label={alreadyMemberField.label}
                  checked={get(initialValues, alreadyMemberPath) === true}
                  {...field}
                  onChange={alreadyMemberField.onChange}
                />
              )}
            </FormField>
          </Col>
          {get(initialValues, alreadyMemberPath) && (
            <Col lg={24} xs={24}>
              <FormField
                path={membershipNumberField.path}
                label={membershipNumberField.label}
                required={membershipNumberField.required}
                disabled={membershipNumberField.disabled}
              >
                {(field) => (
                  <Input
                    placeholder={MEMBERSHIP.MEMBERSHIP_NUMBER.PLACEHOLDER}
                    label={membershipNumberField.label}
                    icon={<MdOutlineFreeCancellation size={16} />}
                    defaultValue={membershipNumberField.defaultValue}
                    {...field}
                    onChange={membershipNumberField.onChange}
                    onBlur={membershipNumberField.onBlur}
                  />
                )}
              </FormField>
            </Col>
          )}
        </Row>
      </Form>
    </div>
  );
};

export default MemberShip;
